import type { NewObject } from '@os/doc';
import type { Point } from '@os/engine';
import { isHttpUrl, parseEmbedUrl } from '@os/shared';

export const EMBED_SIZE = { w: 640, h: 360 };
export const LINK_SIZE = { w: 360, h: 120 };

/** A video embed for YouTube/Vimeo/Drive URLs, a link card for any other http(s) URL, centred on `at`; null otherwise. */
export function linkOrEmbedFor(raw: string, at: Point): NewObject | null {
  const url = raw.trim();
  if (!isHttpUrl(url)) return null;
  const base = { parentId: null, rotation: 0, locked: false, style: {} };
  const embed = parseEmbedUrl(url);
  const size = embed ? EMBED_SIZE : LINK_SIZE;
  const box = { x: at.x - size.w / 2, y: at.y - size.h / 2, ...size };
  return embed
    ? { ...base, ...box, type: 'embed', url, provider: embed.provider, embedId: embed.id, title: '', thumbAssetId: null, embeddable: null }
    : { ...base, ...box, type: 'link', url, title: '', description: '', siteName: '', thumbAssetId: null, status: 'pending' };
}
